import { FormField, Toggle } from '@amzn/awsui-components-react'

const TableIsActiveInput = (props) => {
    const { id, isActive, onIsActiveChange, readOnly = false } = props

    return (
        <FormField>
            <Toggle
                checked={isActive}
                onChange={({ detail }) => {
                    onIsActiveChange(id, 'isActive', detail.checked)
                }}
                readOnly={readOnly}
            />
        </FormField>
    )
}

export default TableIsActiveInput
